import { useTLang } from 'intl/intl';

export function useOrderDetailDialogProductsSectionLang() {
  return {
    auditable: useTLang({ id: 'orderDetailDialog.auditable.msg' }),
  };
}
